import React from "react";
import {observer} from "mobx-react";
import Utility from "../../Utility";
import GeneralDialog from "./GeneralDialog";
import TextField from "@mui/material/TextField";
import {Button} from "@mui/material";
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import {useStores} from "../../Hooks";

const baseUrl = Utility.getBaseUrl();

const ProcedurePublishedModal = observer(() => {
    const {generalStore, modalStore} = useStores();


    function viewProcedure() {
        const url = getShareLink();
        window.open(url);
    }

    function getShareLink() {
        return `${baseUrl}/deep/view/${generalStore.workspace}/${modalStore.modalData.sharingId}`
    }

    async function copyLink() {
        await navigator.clipboard.writeText(getShareLink());
        modalStore.showSuccessMessage(generalStore.translate('linkCopied'))
    }

    async function close() {
        modalStore.isProcedurePublishedModalOpen = false;
        await modalStore.modalData.onClose();
        delete modalStore.modalData.onClose;
    }

    return (
        <GeneralDialog
            specialOnClose={close}
            openControl='isProcedurePublishedModalOpen'
            className='blue-dialog procedure-published-dialog'
            data-testid="procedure-published-dialog"
            onEnter={null}
            title={generalStore.translate('publishedSuccessfully')}
            body={
                <div>
                    <div className='title-container'>
                        {generalStore.translate('publishedConfirmSentence')}
                    </div>
                    <div className='procedure-published-input-container'>
                        <TextField autoFocus className='procedure-published-link-input' readOnly fullWidth
                                   variant='outlined'
                                   value={getShareLink()}
                                   inputProps={{'data-testid': 'procedure-published-link'}}
                        />
                        <Button className='procedure-published-view-button' variant='outlined'
                                onClick={viewProcedure}>{generalStore.translate('view')}</Button>
                    </div>
                    <Button className='procedure-published-copy-button' variant='outlined'
                            onClick={copyLink}><FileCopyOutlinedIcon/>{generalStore.translate('copy')}</Button>
                </div>
            }
            onConfirm={close}
            confirmText={generalStore.translate('done')}
            noCancel
        />
    );
});

export default ProcedurePublishedModal;
